// extracted by mini-css-extract-plugin
export default {"badge":"VinBadge_badge__wLtTA","icon":"VinBadge_icon__Gqygl","label":"VinBadge_label__m0A0U","code":"VinBadge_code__D45zC"};